/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const CONSOLE_FUNCTIONS = {
	info: console.info.bind(console),
	warn: console.warn.bind(console),
	error: console.error.bind(console),
	debug: console.debug.bind(console),
	trace: console.trace.bind(console)
};

class Logger {

	constructor(identifier) {
		this._identifier = identifier;
		this.CONSOLE_FUNCTIONS = CONSOLE_FUNCTIONS;
	}

	_parseMessage(message) {
		let msg;
		if (message instanceof Error) {
			msg = message.stack;
		} else if (typeof message === 'string' || typeof message.toString === 'function') {
			msg = message;
		} else {
			msg = JSON.stringify(message, null, '\t');
		}
		return msg;
	}

	/**
	 * Logs a message
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 * @param {string} [level=info] - the level for the log message
	 */
	log(message, level = 'info') {
		const msg = this._parseMessage(message);
		const lvl = level.toUpperCase(level);
		const fn = this.CONSOLE_FUNCTIONS[level];
		if (!fn) {
			throw new Error(`Unable to log message ${msg}; level ${level}`);
		}
		fn(`[${lvl}] [${this._identifier}] ${msg}`);
	}

	/**
	 * Logs a message at error level
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 */
	error(message) {
		this.log(message, 'error');
	}

	/**
	 * Logs a message at warn level
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 */
	warn(message) {
		this.log(message, 'warn');
	}

	/**
	 * Logs a message at info level
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 */
	info(message) {
		this.log(message, 'info');
	}

	/**
	 * Logs a message at debug level
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 */
	debug(message) {
		this.log(message, 'debug');
	}

	/**
	 * Logs a message at trace level
	 * @param {(string|Object)} message - the message, Error, or JSON object
	 */
	trace(message) {
		this.log(message, 'trace');
	}
}

export default Logger;



// WEBPACK FOOTER //
// ./src/js/util/Logger.js